/**
 * Create reducers for handling action response from API middleware.
 *
 * @param {Object} types          Action types used in API redux middleware
 * @param {String} types.request
 * @param {String} types.receive
 * @param {String} types.failure
 * @return {Function} reducer
 */

export default ({ request, receive, failure }, initialState = {}) => (state = initialState, { type, payload, error }) => {
  switch (type) {
    case request:
      return {
        ...state,
        isRequesting: true,
        didRequest: false,
        didRequestFail: null
      }
    case receive:
      return {
        ...state,
        isRequesting: false,
        didRequest: true,
        didRequestFail: false,
        data: payload.response
      }
    case failure:
      return {
        ...state,
        isRequesting: false,
        didRequestFail: true,
        didRequest: true,
        error: error && error.message
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/utils/create-api-middleware-reducer.js